/*
 * @Description:
 * @Author: yangsibo
 * @Date: 2023-06-06 19:54:32
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-11-28 15:30:33
 * @FilePath: /co-op.visual.com/src/main.js
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "@/api/api";
import "@/styles/reset.css";
import "./assets/iconfont/iconfont.css";
import "./styles/global.scss";
import "./styles/awardCeremony.scss";
import { dictMixin } from "./utils/mixins";

import * as echarts from "echarts";
import common, { os } from "./utils/common";
// 引入element-ui
import ElementUI, { Message } from "element-ui";
// 自定义主题色
import "./styles/element-variables.scss";
import directive from "@/directives";

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.mixin(dictMixin);

Vue.use(ElementUI);
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
Vue.use(preview)
// 重写$message
const $message = (options) => {
  return Message({
    ...options,
    duration: 2000,
  });
};
["success", "warning", "info", "error"].forEach((type) => {
  $message[type] = (options) => {
    if (typeof options === "string") {
      options = {
        message: options,
      };
    }
    options.type = type;
    options.duration = 2000;
    return Message(options);
  };
});
// 加载远程js
Vue.component("remote-js", {
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  render: function (createElement) {
    var self = this;
    return createElement("script", {
      attrs: {
        type: "text/javascript",
        src: this.src,
      },
      on: {
        load: function (event) {
          self.$emit("load", event);
        },
        error: function (event) {
          self.$emit("error", event);
        },
        readystatechange: function (event) {
          if (this.readyState === "complete") {
            self.$emit("load", event);
          }
        },
      },
    });
  },
});
Vue.prototype.$echarts = echarts;
//将http挂载到vue的原型上
Vue.prototype.$http = http;
Vue.prototype.$common = common;

// 挂载全局系统标识变量
Vue.prototype.$os = os();
// 加载指令
directive(Vue);
//将默认图挂载到vue的原型上
// Vue.prototype.$thumb = require("./assets/thumb.gif");
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount("#app");
